/**
 * VELUREA PREMIUM JS
 * Dark Mode Toggle — saves preference in localStorage
 */
document.addEventListener('DOMContentLoaded', () => {

  // ── DARK MODE TOGGLE ──
  const DARK_KEY = 'velurea-dark-mode';

  function applyDarkMode(isDark) {
    if (isDark) {
      document.body.classList.add('v-dark-mode');
    } else {
      document.body.classList.remove('v-dark-mode');
    }
    // update all toggle buttons on page
    document.querySelectorAll('.v-theme-toggle').forEach(btn => {
      btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      btn.querySelector('.v-toggle-icon').textContent = isDark ? '☀️' : '🌙';
      const textSpan = btn.querySelector('.v-toggle-text');
      if(textSpan) textSpan.textContent = isDark ? 'LIGHT MODE' : 'DARK MODE';
      btn.setAttribute('title', isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode');
    });
  }

  // Load saved preference
  const saved = localStorage.getItem(DARK_KEY);
  applyDarkMode(saved === 'true');

  // Inject toggle button into header icons area
  function injectToggleButton() {
    // Dawn header icons wrapper
    const headerIcons = document.querySelector('.header__icons');
    if (!headerIcons) return;

    // Avoid duplicates
    if (document.querySelector('.v-theme-toggle')) return;

    const isDark = document.body.classList.contains('v-dark-mode');

    const btn = document.createElement('button');
    btn.className = 'v-theme-toggle header__icon';
    btn.setAttribute('type', 'button');
    btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    btn.setAttribute('title', isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode');
    btn.setAttribute('aria-label', 'Toggle dark mode');
    btn.innerHTML = `<span class="v-toggle-icon" aria-hidden="true">${isDark ? '☀️' : '🌙'}</span><span class="v-toggle-text" style="font-family: var(--v-font-body); font-size: 0.65rem; letter-spacing: 0.1em; font-weight: 500; margin-left: 0.5rem; white-space: nowrap;">${isDark ? 'LIGHT MODE' : 'DARK MODE'}</span>`;
    btn.style.cssText = "display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.03); border-radius: 50px; padding: 0.2rem 1rem; width: auto; height: 35px; border: 1px solid var(--v-border);";

    btn.addEventListener('click', () => {
      const nowDark = !document.body.classList.contains('v-dark-mode');
      localStorage.setItem(DARK_KEY, nowDark ? 'true' : 'false');
      applyDarkMode(nowDark);
    });

    // Insert before first child (before search icon)
    headerIcons.insertBefore(btn, headerIcons.firstChild);
  }

  injectToggleButton();
});
